// extracted by mini-css-extract-plugin
module.exports = {"modal_body":"WarningDxSyc_modal_body__3Zsz_","title":"WarningDxSyc_title__2Lgru","content":"WarningDxSyc_content__9Fmaw"};